import MenuIcon from '@mui/icons-material/Menu'
import { useEffect } from 'react';

export default function Header(props = {}) {

    useEffect(() => {
        var body = document.body;
        if(body.className.indexOf('sidebar-collapse') === -1){
            body.className += ' sidebar-collapse';
        } else {
            body.className = body.className.replace(' sidebar-collapse', '');
        }
    })
    // const pushMenu = () => {
    //     var body = document.body;
    //     if(body.clientWidth > 768){
    //         if(body.className.indexOf('sidebar-collapse') === -1){
    //             body.className += ' sidebar-collapse';
    //         } else {
    //             body.className = body.className.replace(' sidebar-collapse', '');
    //         }
    //     }else{
    //         if (body.className.indexOf('sidebar-open') === -1) {
    //             body.className += ' sidebar-open';
    //         } else {
    //             body.className = body.className.replace(' sidebar-open', '');
    //         }
    //     }
    // }
  
    return (
        <header className="main-header">
            <a href="#" className="logo">
            {props.appName}
            </a>
            {/* <nav className="navbar navbar-static-top" role="navigation">
                <a href="#" className="sidebar-toggle" data-toggle="offcanvas" role="button">
                    <MenuIcon/><span className="sr-only"> Toggle navigation</span>
                </a>
            </nav> */}
        </header>
    )
}